import { SET_CURRENT_RESOURCE_TYPE } from "./type";

export const setCurrentResourceType = (type) => async (dispatch) => {
  dispatch({
    type: SET_CURRENT_RESOURCE_TYPE,
    payload: type,
  });
};
